<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Dashboard</h3>
      </div>
      <div class="layout__controls">
        <div class="card">
          <div class="card__content">
            <div class="form-inline">
              <div class="form-field select">
                <div class="select-field">
                  <select
                    @change="changeTipoFecha"
                    name="tipo_fecha"
                    v-model="form.tipo_fecha"
                    id="tipo_fecha"
                  >
                    <option value="A">A la fecha</option>
                    <option value="P">Personalizado</option>
                  </select>
                  <label for="tipo_fecha">Tipo de consulta</label>
                </div>
              </div>
              <div v-show="form.tipo_fecha === 'P'" class="form-field">
                <div class="datepicker-field datepicker-field--stretch">
                  <VueCtkDateTimePicker
                    id="desde"
                    v-model="form.desde"
                    locale="es"
                    no-label
                    only-date
                    auto-close
                    button-now-translation="Ahora"
                    format="YYYY-MM-DD"
                    formatted="YYYY-MM-DD"
                    label="Seleccione una fecha..."
                  />
                  <label for="desde" class="label-nowrap">Desde</label>
                  <span v-if="errores.desde" class="helper-text text-danger" slot="helper">
                    <strong>{{ errores.desde[0] }}</strong>
                  </span>
                </div>
              </div>
              <div v-show="form.tipo_fecha === 'P'" class="form-field">
                <div class="datepicker-field datepicker-field--stretch">
                  <VueCtkDateTimePicker
                    id="hasta"
                    v-model="form.hasta"
                    locale="es"
                    no-label
                    only-date
                    auto-close
                    button-now-translation="Ahora"
                    format="YYYY-MM-DD"
                    formatted="YYYY-MM-DD"
                    label="Seleccione una fecha..."
                  />
                  <label class="label-nowrap" for="hasta">Hasta</label>
                  <span v-if="errores.hasta" class="helper-text text-danger" slot="helper">
                    <strong>{{ errores.hasta[0] }}</strong>
                  </span>
                </div>
              </div>
              <button @click="consultar" type="button" class="btn-info">
                <i class="fa fa-search"></i>
                <span>Consultar</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="grid grid--fit">
      <button-card
        btn-color="btn-light"
        fa-name="fa-users"
        :counter="usuariosSistema"
      >USUARIOS EN EL SISTEMA</button-card>
      <button-card
        :format="int"
        btn-color="btn-light"
        fa-name="fa-cloud"
        :counter="documentosRobot"
      >DOCUMENTOS EXTRAÍDOS POR MYBILLBOT</button-card>
    </div>
    <div class="grid grid--fit">
      <info-box
        :quantity="cantidadesVenta"
        enableQuantity
        :totalVal="moneyFormat(montosVenta)"
        title="FV"
        descripcion="Ventas"
        showButton
        :displayAnimation="animations.displayFV"
        @showCharts="mostrarFV"
      ></info-box>
      <info-box
        enableQuantity
        :quantity="cantidadesDv"
        colorClass="info-box__abrv--danger"
        :totalVal="moneyFormat(montosDv)"
        title="DV"
        descripcion="Devoluciones en venta"
        showButton
        :displayAnimation="animations.displayDV"
        @showCharts="mostrarDV"
      ></info-box>
      <info-box
        enableQuantity
        :quantity="cantidadesRentaClientes"
        colorClass="info-box__abrv--bus300"
        :totalVal="moneyFormat(montosRentaClientes)"
        title="RC"
        descripcion="Retenciones de renta de clientes"
        showButton
        :displayAnimation="animations.displayRC"
        @showCharts="mostrarRC"
      ></info-box>
    </div>
    <div class="mb-3">
      <transitionCharts
        :title="'Facturas de ventas'"
        :nameOption="'optionFV'"
        :displayAnimation="animations.displayFV"
        :totalMontoElect="totalMontoElectFV"
        :totalCantElect="totalCantElectFV"
        :totalMontoManual="totalMontoManualFV"
        :totalCantManual="totalCantManualFV"
        :dataChartMontoManual="dataChartMontoManualFV"
        :dataChartCantManual="dataChartCantManualFV"
        :dataChartMontoElect="dataChartMontoElectFV"
        :dataChartCantElect="dataChartCantElectFV"
      ></transitionCharts>  
    </div>     
    <div class="mb-3">
      <transitionCharts
        :title="'Devoluciones de ventas'"
        :nameOption="'optionDV'"
        :displayAnimation="animations.displayDV"
        :totalMontoElect="totalMontoElectDV"
        :totalCantElect="totalCantElectDV"
        :totalMontoManual="totalMontoManualDV"
        :totalCantManual="totalCantManualDV"
        :dataChartMontoManual="dataChartMontoManualDV"
        :dataChartCantManual="dataChartCantManualDV"
        :dataChartMontoElect="dataChartMontoElectDV"
        :dataChartCantElect="dataChartCantElectDV"
      ></transitionCharts>  
    </div>    
    <div class="mb-3">
      <transitionCharts
        :title="'Retenciones de renta de clientes'"
        :nameOption="'optionRC'"
        :displayAnimation="animations.displayRC"
        :totalMontoElect="totalMontoElectRC"
        :totalCantElect="totalCantElectRC"
        :totalMontoManual="totalMontoManualRC"
        :totalCantManual="totalCantManualRC"
        :dataChartMontoManual="dataChartMontoManualRC"
        :dataChartCantManual="dataChartCantManualRC"
        :dataChartMontoElect="dataChartMontoElectRC"
        :dataChartCantElect="dataChartCantElectRC"
      ></transitionCharts>  
    </div>  
    <div class="grid grid--fit">
      <info-box
        enableQuantity
        :quantity="cantidadesIVAClientes"
        colorClass="info-box__abrv--dark"
        :totalVal="moneyFormat(montosIVAClientes)"
        title="IC"
        descripcion="Retenciones de IVA de clientes"
        showButton
        :displayAnimation="animations.displayIC"
        @showCharts="mostrarIC"
      ></info-box>
      <info-box
        colorClass="info-box__abrv--success"
        :totalVal="moneyFormat(recaudadoAbonos)"
        title="AB"
        descripcion="Recaudación de abonos"
      ></info-box>
      <info-box
        colorClass="info-box__abrv--warning"
        :totalVal="moneyFormat(montosCompra)"
        title="CO"
        :quantity="cantidadesCompra"
        enableQuantity
        descripcion="Compras"
      ></info-box>
    </div>
    <div class="mb-3">
      <transitionCharts
        :title="'Retenciones de IVA de clientes'"
        :nameOption="'optionIC'"
        :displayAnimation="animations.displayIC"
        :totalMontoElect="totalMontoElectIC"
        :totalCantElect="totalCantElectIC"
        :totalMontoManual="totalMontoManualIC"
        :totalCantManual="totalCantManualIC"
        :dataChartMontoManual="dataChartMontoManualIC"
        :dataChartCantManual="dataChartCantManualIC"
        :dataChartMontoElect="dataChartMontoElectIC"
        :dataChartCantElect="dataChartCantElectIC"
      ></transitionCharts>  
    </div> 
    <div class="grid grid--fit">
      <info-box
        enableQuantity
        :quantity="cantidadesDc"
        colorClass="info-box__abrv--secondary"
        :totalVal="moneyFormat(montosDc)"
        title="DC"
        descripcion="Devoluciones en compras"
      ></info-box>
      <info-box
        enableQuantity
        :quantity="cantidadesRentaProveedores"
        colorClass="info-box__abrv--bus400"
        :totalVal="moneyFormat(montosRentaProveedores)"
        title="RP"
        descripcion="Retenciones de renta a proveedores"
      ></info-box>
      <info-box
        enableQuantity
        :quantity="cantidadesIVAProveedores"
        colorClass="info-box__abrv--primary"
        :totalVal="moneyFormat(montosIVAProveedores)"
        title="RP"
        descripcion="Retenciones de IVA a proveedores"
      ></info-box>
    </div>
    <div class="grid grid--fit">
      <info-box
        colorClass="info-box__abrv--warning"
        :totalVal="moneyFormat(cuentasPorCobrar)"
        title="CC"
        descripcion="Cuentas por cobrar"
      ></info-box>
      <info-box
        colorClass="info-box__abrv--success"
        :totalVal="moneyFormat(liquidez)"
        title="LQ"
        descripcion="Liquidez"
      ></info-box>
      <info-box
        colorClass="info-box__abrv--info"
        :totalVal="moneyFormat(comisiones)"
        title="CV"
        descripcion="Comisiones de vendedores"
      ></info-box>
    </div>
    <div class="row mt-3">
      <div class="col-xs-12 col-md-4">
        <div class="card">
          <div class="card__title">
            <h5>Comisiones por vendedores</h5>
          </div>
          <div class="card__content">
            <pie-chart v-show="comisionesPorVendedores.length > 0" :data="comisionesPorVendedores"></pie-chart>
            <p v-show="comisionesPorVendedores.length === 0">
              <strong>No se ha encontrado información.</strong>
            </p>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="card">
          <div class="card__title">
            <h5>Recaudación de abonos</h5>
          </div>
          <div class="card__content">
            <pie-chart v-show="recaudacionAbonosCxc.length > 0" :data="recaudacionAbonosCxc"></pie-chart>
            <p v-show="recaudacionAbonosCxc.length === 0">
              <strong>No se ha encontrado información.</strong>
            </p>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="card">
          <div class="card__title">
            <h5>Órdenes de trabajo</h5>
          </div>
          <div class="card__content">
            <column-chart v-show="ordenesTrabajo.length > 0" :data="ordenesTrabajo"></column-chart>
            <p v-show="ordenesTrabajo.length === 0">
              <strong>No se ha encontrado información.</strong>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-xs-12">
        <div class="card">
          <div class="card__title">
            <h5>Distribución entre ventas y compras (anual)</h5>
            <div class="card__controls">
              <div class="form-field select select--stretch">
                <div class="select-field select-field--stretch">
                  <select @input="consultar" name="periodo" v-model="form.periodo" id="periodo">
                    <option :value="periodo" :key="periodo" v-for="periodo in periodos">
                      {{ periodo }}
                    </option>
                  </select>
                  <label for="periodo">Período</label>
                </div>
              </div>
            </div>
          </div>
          <div class="card__content">
            <line-chart :data="arrayMeses" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      periodos: [],
      arrayMeses: [],
      cantidadesDc: 0,
      cantidadesIVAProveedores: 0,
      cantidadesVenta: 0,
      int: intFormat,
      moneyFormat: decimalFormat,
      form: {
        tipo_fecha: "A",
        desde: moment(new Date()).format("YYYY-MM-DD"),
        hasta: moment(new Date()).format("YYYY-MM-DD"),
        periodo: parseInt(moment(new Date()).format("YYYY"))
      },
      cantidadesIVAClientes: 0,
      errores: {},
      montosVenta: 0,
      montosCompra: 0,
      montosRentaClientes: 0,
      montosIVAClientes: 0,
      montosRentaProveedores: 0,
      montosIVAProveedores: 0,
      liquidez: 0,
      usuariosSistema: 0,
      documentosRobot: 0,
      facturasTotalesAbonadas: 0,
      recaudadoAbonos: 0,
      cuentasPorCobrar: 0,
      comisionesPorVendedores: [],
      recaudacionAbonosCxc: [],
      comisiones: 0,
      montosDv: 0,
      montosDc: 0,
      ordenesTrabajo: [],
      cantidadesCompra: 0,
      cantidadesRentaClientes: 0,
      cantidadesRentaProveedores: 0,
      cantidadesDv: 0,
      animations: {
        displayFV: false,
        displayDV: false,
        displayRC: false,
        displayIC: false,
      },
      //Facturas de venta (FV)
      dataChartMontoManualFV: [],
      dataChartCantManualFV: [],
      dataChartMontoElectFV: [],
      dataChartCantElectFV: [],
      totalMontoElectFV: 0,
      totalCantElectFV: 0,
      totalMontoManualFV: 0,
      totalCantManualFV: 0,
      //Devoluciones de venta (DV)
      dataChartMontoManualDV: [],
      dataChartCantManualDV: [],
      dataChartMontoElectDV: [],
      dataChartCantElectDV: [],
      totalMontoElectDV: 0,
      totalCantElectDV: 0,
      totalMontoManualDV: 0,
      totalCantManualDV: 0,    
      //Retenciones de renta de clientes (RC)
      dataChartMontoManualRC: [],
      dataChartCantManualRC: [],
      dataChartMontoElectRC: [],
      dataChartCantElectRC: [],
      totalMontoElectRC: 0,
      totalCantElectRC: 0,
      totalMontoManualRC: 0,
      totalCantManualRC: 0,    
      //Retenciones de IVA de clientes (IC)
      dataChartMontoManualIC: [],
      dataChartCantManualIC: [],
      dataChartMontoElectIC: [],
      dataChartCantElectIC: [],
      totalMontoElectIC: 0,
      totalCantElectIC: 0,
      totalMontoManualIC: 0,
      totalCantManualIC: 0,  
    };
  },
  methods: {
    changeTipoFecha: function() {
      if (this.form.tipo_fecha === "P") {
        let now = new Date();
        now.setDate(1);
        this.form.desde = moment(now).format("YYYY-MM-DD");
        this.form.hasta = moment(new Date()).format("YYYY-MM-DD");
      }
    },
    consultar: function() {
      axios
        .get(url + "/home", {
          params: this.form
        })
        .then(({ data }) => {
          this.cantidadesVenta = data.cantidadesVenta;
          this.montosVenta = data.montosVenta;
          this.montosCompra = data.montosCompra;
          this.montosRentaClientes = data.montosRentaClientes;
          this.montosIVAClientes = data.montosIVAClientes;
          this.montosRentaProveedores = data.montosRentaProveedores;
          this.montosIVAProveedores = data.montosIVAProveedores;
          this.montosDv = data.montosDv;
          this.montosDc = data.montosDc;
          this.liquidez = data.liquidez;
          this.usuariosSistema = data.usuariosSistema;
          this.documentosRobot = data.documentosRobot;
          this.facturasTotalesAbonadas = data.facturasTotalesAbonadas;
          this.recaudadoAbonos = data.recaudadoAbonos;
          this.cuentasPorCobrar = data.cuentasPorCobrar;
          this.comisionesPorVendedores = data.comisionesPorVendedores;
          this.recaudacionAbonosCxc = data.recaudacionAbonosCxc;
          this.comisiones = data.comisiones;
          this.ordenesTrabajo = data.ordenesTrabajo;
          this.cantidadesCompra = data.cantidadesCompra;
          this.cantidadesRentaClientes = data.cantidadesRentaClientes;
          this.cantidadesIVAClientes = data.cantidadesIVAClientes;
          this.cantidadesRentaProveedores = data.cantidadesRentaProveedores;
          this.cantidadesIVAProveedores = data.cantidadesIVAProveedores;
          this.cantidadesDv = data.cantidadesDv;
          this.cantidadesDc = data.cantidadesDc;
          this.arrayMeses = data.arrayMeses;
        });
    },
    consultarFV: function() {
      let that = this;
      let urlApi = url + '/kdashboard/obtener-datos/FV';
      axios.post(urlApi, this.form).then(function (response) {
        let data = response.data;
        that.dataChartMontoManualFV.splice(0, that.dataChartMontoManualFV.length);
        that.dataChartCantManualFV.splice(0, that.dataChartCantManualFV.length);
        that.dataChartMontoElectFV.splice(0, that.dataChartMontoElectFV.length);
        that.dataChartCantElectFV.splice(0, that.dataChartCantElectFV.length);
        that.dataChartMontoManualFV = [
          ['Emitido', data.montoManualEmitidas], ['Anulado', data.montoManualAnuladas]
        ];
        that.dataChartCantManualFV = [
          ['Emitido', data.cantManualEmitidas], ['Anulado', data.cantManualAnuladas]
        ];
        that.dataChartMontoElectFV = [
          ['Emitido', data.montoElectEmitidas], ['Autorizado', data.montoElectAutorizadas], 
          ['No Autorizado', data.montoElectNoAutorizadas], ['Pendiente', data.montoElectPendientes], 
          ['Anulado', data.montoElectAnuladas], ['Anul./Autoriz.', data.montoElectAnuladasAutorizadas]
        ];
        that.dataChartCantElectFV = [
          ['Emitido', data.cantElectEmitidas], ['Autorizado', data.cantElectAutorizadas], 
          ['No Autorizado', data.cantElectNoAutorizadas], ['Pendiente', data.cantElectPendientes], 
          ['Anulado', data.cantElectAnuladas], ['Anul./Autoriz.', data.cantElectAnuladasAutorizadas]
        ];
        that.totalMontoElectFV = data.montoElectEmitidas +  data.montoElectAutorizadas + data.montoElectNoAutorizadas + data.montoElectPendientes;
        that.totalCantElectFV =  data.cantElectEmitidas + data.cantElectAutorizadas + data.cantElectNoAutorizadas + data.cantElectPendientes;
        that.totalMontoManualFV = data.montoManualEmitidas;
        that.totalCantManualFV =  data.cantManualEmitidas;
      }).catch(function (error) {
        swal('Error', 'No se pudo consultar los datos de FV', 'error');
      });
    },    
    consultarDV: function() {
      let that = this;
      let urlApi = url + '/kdashboard/obtener-datos/DV';
      axios.post(urlApi, this.form).then(function (response) {
        let data = response.data;
        that.dataChartMontoManualDV.splice(0, that.dataChartMontoManualDV.length);
        that.dataChartCantManualDV.splice(0, that.dataChartCantManualDV.length);
        that.dataChartMontoElectDV.splice(0, that.dataChartMontoElectDV.length);
        that.dataChartCantElectDV.splice(0, that.dataChartCantElectDV.length);
        that.dataChartMontoManualDV = [
          ['Emitido', data.montoManualEmitidas], ['Anulado', data.montoManualAnuladas]
        ];
        that.dataChartCantManualDV = [
          ['Emitido', data.cantManualEmitidas], ['Anulado', data.cantManualAnuladas]
        ];
        that.dataChartMontoElectDV = [
          ['Emitido', data.montoElectEmitidas], ['Autorizado', data.montoElectAutorizadas], 
          ['No Autorizado', data.montoElectNoAutorizadas], ['Pendiente', data.montoElectPendientes], 
          ['Anulado', data.montoElectAnuladas], ['Anul./Autoriz.', data.montoElectAnuladasAutorizadas]
        ];
        that.dataChartCantElectDV = [
          ['Emitido', data.cantElectEmitidas], ['Autorizado', data.cantElectAutorizadas], 
          ['No Autorizado', data.cantElectNoAutorizadas], ['Pendiente', data.cantElectPendientes], 
          ['Anulado', data.cantElectAnuladas], ['Anul./Autoriz.', data.cantElectAnuladasAutorizadas]
        ];
        that.totalMontoElectDV = data.montoElectEmitidas +  data.montoElectAutorizadas + data.montoElectNoAutorizadas + data.montoElectPendientes;
        that.totalCantElectDV =  data.cantElectEmitidas + data.cantElectAutorizadas + data.cantElectNoAutorizadas + data.cantElectPendientes;
        that.totalMontoManualDV = data.montoManualEmitidas;
        that.totalCantManualDV =  data.cantManualEmitidas;
      }).catch(function (error) {
        swal('Error', 'No se pudo consultar los datos de DV', 'error');
      });
    },
    consultarRC: function() {
      let that = this;
      let urlApi = url + '/kdashboard/obtener-datos/RC';
      axios.post(urlApi, this.form).then(function (response) {
        let data = response.data;
        that.dataChartMontoManualRC.splice(0, that.dataChartMontoManualRC.length);
        that.dataChartCantManualRC.splice(0, that.dataChartCantManualRC.length);
        that.dataChartMontoElectRC.splice(0, that.dataChartMontoElectRC.length);
        that.dataChartCantElectRC.splice(0, that.dataChartCantElectRC.length);
        that.dataChartMontoManualRC = [
          ['Autorizado', data.montoManualAutorizadas], ['Anulado', data.montoManualAnuladas]
        ];
        that.dataChartCantManualRC = [
          ['Autorizado', data.cantManualAutorizadas], ['Anulado', data.cantManualAnuladas]
        ];
        that.dataChartMontoElectRC = [
          ['Autorizado', data.montoElectAutorizadas], ['Anulado', data.montoElectAnuladas]
        ];
        that.dataChartCantElectRC = [
          ['Autorizado', data.cantElectAutorizadas], ['Anulado', data.cantElectAnuladas]
        ];
        that.totalMontoElectRC = data.montoElectAutorizadas;
        that.totalCantElectRC =  data.cantElectAutorizadas;
        that.totalMontoManualRC = data.montoManualAutorizadas;
        that.totalCantManualRC =  data.cantManualAutorizadas;
      }).catch(function (error) {
        swal('Error', 'No se pudo consultar los datos de RC', 'error');
      });
    },    
    consultarIC: function() {
      let that = this;
      let urlApi = url + '/kdashboard/obtener-datos/IC';
      axios.post(urlApi, this.form).then(function (response) {
        let data = response.data;
        that.dataChartMontoManualIC.splice(0, that.dataChartMontoManualIC.length);
        that.dataChartCantManualIC.splice(0, that.dataChartCantManualIC.length);
        that.dataChartMontoElectIC.splice(0, that.dataChartMontoElectIC.length);
        that.dataChartCantElectIC.splice(0, that.dataChartCantElectIC.length);
        that.dataChartMontoManualIC = [
          ['Autorizado', data.montoManualAutorizadas], ['Anulado', data.montoManualAnuladas]
        ];
        that.dataChartCantManualIC = [
          ['Autorizado', data.cantManualAutorizadas], ['Anulado', data.cantManualAnuladas]
        ];
        that.dataChartMontoElectIC = [
          ['Autorizado', data.montoElectAutorizadas], ['Anulado', data.montoElectAnuladas]
        ];
        that.dataChartCantElectIC = [
          ['Autorizado', data.cantElectAutorizadas], ['Anulado', data.cantElectAnuladas]
        ];
        that.totalMontoElectIC = data.montoElectAutorizadas;
        that.totalCantElectIC =  data.cantElectAutorizadas;
        that.totalMontoManualIC = data.montoManualAutorizadas;
        that.totalCantManualIC =  data.cantManualAutorizadas;
      }).catch(function (error) {
        swal('Error', 'No se pudo consultar los datos de IC', 'error');
      });
    },    
    mostrarFV: function() {
      if (!this.animations.displayFV) {
        this.animations.displayFV = true;
        this.consultarFV();
      } else {
        this.animations.displayFV = false;
      }
    },
    mostrarDV: function() {
      if (!this.animations.displayDV) {
        this.animations.displayDV = true;
        this.consultarDV();
      } else {
        this.animations.displayDV = false;
      }
    },
    mostrarRC: function() {
      if (!this.animations.displayRC) {
        this.animations.displayRC = true;
        this.consultarRC();
      } else {
        this.animations.displayRC = false;
      }
    },
    mostrarIC: function() {
      if (!this.animations.displayIC) {
        this.animations.displayIC = true;
        this.consultarIC();
      } else {
        this.animations.displayIC = false;
      }
    },
    reiniciarAnimaciones: function() {
      this.animations.displayFV = false;
      this.animations.displayDV = false;
    }
  },
  mounted: function() {
    for (let i = 2018; i <= parseInt(moment(new Date()).format('YYYY')); i ++) {
      this.periodos.push(i);
    }
    this.consultar();
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/KDashboard.vue